import React from 'react';
import { Box, Text, VStack } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

import { OralExamQuestionText } from '@/common/components/OralExamQuestionText';

type Props = {
  question: string;
  fillKind?: string | null;
  fills?: string[] | null;
  hideTitle?: boolean;
};

export function SwapCurrentQuestion({
  question, fillKind, fills, hideTitle = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <VStack space="xs">
      <Text size="2xs" color="$textSubtle" textTransform="uppercase">
        {t('lecturer.scheduledChanges.swap.current')}
      </Text>
      <Box
        bg="$bgSubtle"
        borderWidth={1}
        borderColor="$borderLight"
        borderRadius="$md"
        px="$3"
        py="$2.5"
      >
        <OralExamQuestionText
          size="sm"
          question={question}
          fillKind={fillKind}
          fills={fills}
          showFillSlot
          hideTitle={hideTitle}
        />
      </Box>
    </VStack>
  );
}
